import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import pdf from '../assets/files/politica_de_confidentialitate_protectiadatelor.pdf';

// Styled Footer Component
const Footer = styled(Box)({
  backgroundColor: '#4D8F55',
  color: 'white',
  padding: '50px 60px', // Increased padding for better spacing
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap', // Allow wrapping for smaller screens
});

const FooterColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px', // Increased space between items
});

const FooterLink = styled('a')({
  color: 'white',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

const ContactInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px', // Increased space between contact items
});

const InfoItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '1em', // Increased gap for better visibility
  padding: '5px 0',
});

const FooterComponent = () => {
  return (
    <Footer>
      {/* Left Column: Trademark and Privacy Policy */}
      <FooterColumn>
        <Typography variant="body1">© 2024 Data Cert SRL. All rights reserved.</Typography>
        <FooterLink href={pdf} target="_blank" rel="noreferrer">
          Politica de Confidentialitate
        </FooterLink>
      </FooterColumn>

      {/* Right Column: Contact Information */}
      <FooterColumn>
        <ContactInfo>
          <InfoItem>
            <PhoneIcon sx={{ fontSize: '1.6rem' }} />
            <Typography variant="body2">
              <FooterLink href="tel:0724526752">0724526752</FooterLink>
            </Typography>
          </InfoItem>
          <InfoItem>
            <EmailIcon sx={{ fontSize: '1.6rem' }} />
            <Typography variant="body2">
              <FooterLink href="mailto:info@datacert.ro">info@datacert.ro</FooterLink>
            </Typography>
          </InfoItem>
        </ContactInfo>
      </FooterColumn>
    </Footer>
  );
};

export default FooterComponent;